module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/library/modules/_library.js
// module id = 666
// module chunks = 0